/*
  SAMURA i18n fixes 2026-10-22 (F5, F6). Loaded with defer from layout/theme.liquid.
  F6: languages other than English – any element still shown with text-transform: capitalize (rules in section
      <style> blocks, settings, content loaded later by AJAX) is reset to none. uppercase/lowercase stay.
  F5: desktop header – if the search box gets narrower than MIN_SEARCH px (long localized icon labels), the
      text labels next to the header icons are hidden (html.samura-hdr-compact); the icons and their
      title/aria-label stay. English switches only if the icons would really overlap the search box.
*/
(function () {
  'use strict';
  var html = document.documentElement;
  var lang = (html.getAttribute('lang') || 'en').toLowerCase();
  var isEnglish = lang.indexOf('en') === 0;

  /* ---------- F6 ---------- */
  function resetCapitalize(root) {
    if (isEnglish || !root || root.nodeType !== 1) return;
    var nodes = [root];
    var all = root.getElementsByTagName('*');
    for (var i = 0; i < all.length; i++) nodes.push(all[i]);
    for (var j = 0; j < nodes.length; j++) {
      var el = nodes[j];
      var tag = el.tagName;
      if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'svg' || tag === 'path' || tag === 'LINK' || tag === 'META') continue;
      if (window.getComputedStyle(el).textTransform === 'capitalize') {
        el.style.setProperty('text-transform', 'none', 'important');
      }
    }
  }
  if (!isEnglish) {
    var start = function () {
      resetCapitalize(document.body);
      if ('MutationObserver' in window) {
        var pending = [];
        var timer = null;
        var mo = new MutationObserver(function (records) {
          for (var i = 0; i < records.length; i++) {
            var added = records[i].addedNodes;
            for (var k = 0; k < added.length; k++) {
              if (added[k].nodeType === 1) pending.push(added[k]);
            }
          }
          if (pending.length && !timer) {
            timer = window.setTimeout(function () {
              var list = pending;
              pending = [];
              timer = null;
              for (var n = 0; n < list.length; n++) {
                if (list[n].isConnected) resetCapitalize(list[n]);
              }
            }, 50);
          }
        });
        mo.observe(document.body, { childList: true, subtree: true });
      }
      window.addEventListener('load', function () { resetCapitalize(document.body); });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  }

  /* ---------- F5 ---------- */
  var MIN_SEARCH = 380;
  function headerFit() {
    var form = document.querySelector('.header-top .search-bar form.search_header');
    var meta = document.querySelector('.header-top .header-top-meta');
    if (!form || !meta) return;
    if (window.innerWidth < 1025) {
      html.classList.remove('samura-hdr-compact');
      return;
    }
    /* measure with the labels shown */
    html.classList.remove('samura-hdr-compact');
    var formBox = form.getBoundingClientRect();
    /* English keeps its layout: only a real overlap switches it to compact */
    var tooNarrow = !isEnglish && formBox.width > 0 && formBox.width < MIN_SEARCH;
    var overlap = false;
    var items = meta.querySelectorAll('.header-control > li');
    for (var i = 0; i < items.length; i++) {
      var r = items[i].getBoundingClientRect();
      if (r.width > 0 && r.left < formBox.right - 1) { overlap = true; break; }
    }
    if (tooNarrow || overlap) html.classList.add('samura-hdr-compact');
  }
  var raf = null;
  function scheduleFit() {
    if (raf) return;
    raf = window.requestAnimationFrame(function () { raf = null; headerFit(); });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', headerFit);
  } else {
    headerFit();
  }
  window.addEventListener('load', headerFit);
  window.addEventListener('resize', scheduleFit);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(headerFit);
  /* the cart total next to the cart icon changes after add/remove.
     The theme dispatches these on document.body (CustomEvent without bubbles,
     or jQuery .trigger), so listen on body itself, through jQuery when present. */
  function onCartChange() { window.setTimeout(headerFit, 300); }
  var cartEvents = ['ajax:addToCart', 'ajax:updateCart', 'ajax:deleteCart', 'update:miniCart'];
  function bindCart() {
    if (!document.body) return;
    if (window.jQuery) {
      window.jQuery(document.body).on(cartEvents.join(' '), onCartChange);
    } else {
      for (var c = 0; c < cartEvents.length; c++) document.body.addEventListener(cartEvents[c], onCartChange);
    }
  }
  if (document.body) { bindCart(); } else { document.addEventListener('DOMContentLoaded', bindCart); }
})();
